import { render, staticRenderFns } from "./PMProjects.vue?vue&type=template&id=47f56264&"
import script from "./PMProjects.vue?vue&type=script&lang=ts&"
export * from "./PMProjects.vue?vue&type=script&lang=ts&"
import style0 from "./PMProjects.vue?vue&type=style&index=0&id=47f56264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports